<template>
  <component :is='globalModal' />
  <component :is='layout'/>
</template>

<script lang='ts'>
  import { computed, defineComponent, onMounted, ref, watch } from 'vue'
  import DefaultLayout from './layouts/default.vue'
  import SimpleLayout from './layouts/simple.vue'
  import { useRoute } from 'vue-router'
  import { renderGlobalModal } from '@/utils/modalController'
  import { useAppStore } from '@/store/app'

  export default defineComponent({
    name: 'App',
    components: {
      DefaultLayout,
      SimpleLayout,
    },
    setup() {
      const layout = ref<string>('SimpleLayout')
      const route = useRoute()
      const globalModal = computed(() => renderGlobalModal())
      const appStore = useAppStore()

      onMounted(() => {
        appStore.loadAppConfig()
      })

      watch(
        () => route.meta,
        async meta => {
          try {
            layout.value = meta?.layout as string ?? 'SimpleLayout'
          } catch (e) {
          }
        },
        {
          immediate: true,
        }
      )

      return {
        layout,
        globalModal,
      }
    },
  })

</script>
